import CarClassicContainer from "../../../components/car/detail/CarClassic";

const CarClassic = () => {
  return <CarClassicContainer />;
};

export default CarClassic;
